import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
import _imports_0 from '@/assets/icons/arrows/arr-down-white.svg';
const _hoisted_1 = { class: "dropdown-actions" };
const _hoisted_2 = {
    key: 1,
    class: "btn btn-primary d-flex align-items-center",
    disabled: ""
};
const _hoisted_3 = {
    key: 2,
    class: "dropdown-actions__wrapper dropdown-actions__wrapper--wide"
};
const _hoisted_4 = { class: "dropdown-actions__inner" };
import { ref } from "vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'Dropdown',
    props: {
        title: {
            required: true,
            type: String
        },
        disabled: Boolean
    },
    setup(__props) {
        const isOpen = ref(false);
        return (_ctx, _cache) => {
            const _directive_click_outside = _resolveDirective("click-outside");
            return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
                (!__props.disabled)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "btn btn-primary d-flex align-items-center",
                        onClick: _cache[0] || (_cache[0] = ($event) => (isOpen.value = true))
                    }, [
                        _createTextVNode(_toDisplayString(__props.title) + " ", 1),
                        _cache[1] || (_cache[1] = _createElementVNode("img", {
                            class: "ml-2",
                            src: _imports_0
                        }, null, -1))
                    ]))
                    : (_openBlock(), _createElementBlock("button", _hoisted_2, [
                        _createTextVNode(_toDisplayString(__props.title) + " ", 1),
                        _cache[2] || (_cache[2] = _createElementVNode("img", {
                            class: "ml-2",
                            src: _imports_0
                        }, null, -1))
                    ])),
                (isOpen.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                            _renderSlot(_ctx.$slots, "default")
                        ])
                    ]))
                    : _createCommentVNode("", true)
            ])), [
                [_directive_click_outside, () => (isOpen.value = false)]
            ]);
        };
    }
});
